// Assign carer section for SR detail page.

import { useState } from "react";
import type { JSX } from "react";

export interface CarerItem { _id: string; full_name?: string; city?: string; tier?: number; is_available?: boolean; }

export function AssignCarerSection({ currentCarerId, carers, onAssign }: {
  currentCarerId: string | null;
  carers: CarerItem[];
  onAssign: (id: string) => void;
}): JSX.Element {
  const [selected, setSelected] = useState(currentCarerId ?? "");
  return (
    <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-5 space-y-3">
      <h2 className="text-sm font-semibold text-slate-700">Assign Carer</h2>
      <select value={selected} onChange={(e) => setSelected(e.target.value)}
        className="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-navy-500">
        <option value="">— select a carer —</option>
        {carers.map((c) => (
          <option key={c._id} value={c._id}>
            {c.full_name ?? `C-${c._id.slice(-5).toLowerCase()}`}
            {c.tier ? ` · Tier ${c.tier}` : ""}
            {c.city ? ` · ${c.city}` : ""}
            {c.is_available ? " ✓" : ""}
          </option>
        ))}
      </select>
      <button disabled={!selected} onClick={() => onAssign(selected)}
        className="bg-navy-700 text-white text-sm font-medium px-4 py-2 rounded-lg hover:bg-navy-800 disabled:opacity-40 transition-colors">
        Assign
      </button>
    </div>
  );
}
